import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface LangOption {
  code: string
  name: string
  desc: string
}

interface SettingState {
  listView: boolean
  isSidebarOpen: boolean
  langOptions: LangOption[]
}

const initialState: SettingState = {
  listView: false,
  isSidebarOpen: false,
  langOptions: [],
}

const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    toggleListView: (state) => {
      state.listView = true
    },
    toggleGridView: (state) => {
      state.listView = false
    },
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen
    },
    closeTabletSidebar: (state) => {
      state.isSidebarOpen = false
    },
    loadLangOptions: (state, action: PayloadAction<LangOption[]>) => {
      state.langOptions = action.payload
    },
    reset: () => initialState,
  },
})

export const settingActions = settingSlice.actions
export const settingReducer = settingSlice.reducer
export default settingActions
